import { useState, useEffect } from "react";
import env from "../../../env";
import "./UploadVideo.css";

function UploadVideo(props) {
  const content = props.content;

  const [video, setVideo] = useState(null);
  const [preview, setPreview] = useState("");

  useEffect(() => {
    if (!video) return;

    const uploadVideo = async () => {
      const uploadKey = "videoUrl";

      // شروع آپلود
      props.onUploadStatus?.(uploadKey, "uploading");

      try {
        const res = await fetch(env.siteApi + "/panel/user/upload", {
          method: "POST",
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify({
            base64image: video.base64,
            imgName: video.fileName,
            folderName: "slider",
          }),
        });

        const result = await res.json();

        if (!res.ok || result.error || !result.url) {
          throw new Error(result.error || "Upload failed");
        }

        props.setSliderChange((prev) => ({
          ...prev,
          videoUrl: result.url,
        }));

        // آپلود موفق
        props.onUploadStatus?.(uploadKey, "success");
      } catch (err) {
        console.log(err);

        // آپلود ناموفق
        props.onUploadStatus?.(uploadKey, "error");
      }
    };

    uploadVideo();
  }, [video]);

  const handleVideo = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const reader = new FileReader();

    reader.onload = () => {
      setVideo({
        fileName: file.name,
        base64: reader.result,
      });

      setPreview(URL.createObjectURL(file));
    };

    reader.readAsDataURL(file);
  };

  const src = preview
    ? preview
    : props.sliderChange?.videoUrl
      ? env.siteApiUrl + props.sliderChange.videoUrl
      : content?.videoUrl
        ? env.siteApiUrl + content.videoUrl
        : "";

  return (
    <div className="videos">
      <label className="video-upload-btn">
        انتخاب ویدیو
        <input type="file" accept="video/*" onChange={handleVideo} />
      </label>

      <div className="video-preview">
        {src ? (
          <video controls preload="metadata">
            <source src={src} type="video/mp4" />
            مرورگر شما از پخش ویدیو پشتیبانی نمی‌کند.
          </video>
        ) : (
          <div className="video-placeholder">هنوز ویدیویی انتخاب نشده است</div>
        )}
      </div>
    </div>
  );
}

export default UploadVideo;
